import { fromJS, List, Record } from 'immutable'
import * as types from './actionTypes'
// @ts-ignore
import { FavoriteActivity } from 'store/records/favoriteActivity'
import { FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_ID } from 'app/constants/favoriteActivities'
// @ts-ignore
import { PER_PAGE } from 'app/constants/pagination'
import { IFavoriteActivities } from './interface'

export const initialState = fromJS({
  list: [],
  pagination: {
    current: 0,
    perPage: PER_PAGE,
  },
  filter: {
    byProTrackLevelId: FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_ID,
  },
  pending: {
    getAll: false,
  },
}) as IFavoriteActivities

type Payload = { type: string; payload: any }

export default function(state = initialState, action: Payload) {
  const { type, payload } = action

  switch (type) {
    case types.FAVORITE_ACTIVITIES.GET.REQUEST:
      return state.setIn(['pending', 'getAll'], true)
    case types.FAVORITE_ACTIVITIES.GET.SUCCESS:
      return state
        .set('list', List(payload.data.map((favoriteActivity: any) => new FavoriteActivity(favoriteActivity))))
        .setIn(['pending', 'getAll'], false)
    case types.FAVORITE_ACTIVITIES.DELETE.SUCCESS:
      return state.set('list', state.get('list').filter(({ activityId }) => activityId !== payload.data.data.id))
    case types.FAVORITE_ACTIVITIES.GET.FAIL:
      return state.setIn(['pending', 'getAll'], false)
    case types.FAVORITE_ACTIVITIES_SET_FILTER: {
      const { by, value } = payload
      return state.setIn(['filter', by], value).setIn(['pagination', 'current'], 0)
    }
    case types.FAVORITE_ACTIVITIES_SELECT_PAGE:
      return state.setIn(['pagination', 'current'], payload.page)
    default:
      return state
  }
}
